import React from 'react'
import image1 from '../images/birthday1.jpeg'
import image2 from '../images/birthday2.jpeg'
import image3 from '../images/birthday3.jpeg'
import image4 from '../images/birthday4.jpeg'
import image5 from '../images/birthday5.jpeg'
import image6 from '../images/birthday6.jpeg'
import image7 from '../images/birthday7.jpeg'
import image8 from '../images/birthday8.jpeg'
import image9 from '../images/birthday9.jpeg'
import image10 from '../images/birthday10.jpeg'

export default function BirthdaysAndGraduations() {
  return (
    <div className='sub-gallery-images'>
      <img src={image1} alt='photo' className='sub-gallery-image'/>
      <img src={image2} alt='photo' className='sub-gallery-image'/>
      <img src={image3} alt='photo' className='sub-gallery-image'/>
      <img src={image4} alt='photo' className='sub-gallery-image'/>
      <img src={image5} alt='photo' className='sub-gallery-image'/>
      <img src={image6} alt='photo' className='sub-gallery-image'/>
      <img src={image7} alt='photo' className='sub-gallery-image'/>
      <img src={image8} alt='photo' className='sub-gallery-image'/>
      <img src={image9} alt='photo' className='sub-gallery-image'/>
      <img src={image10} alt='photo' className='sub-gallery-image'/>
    </div>
  )
}
